import { render, staticRenderFns } from "./CreateEmailGroupModal.vue?vue&type=template&id=297c1078&scoped=true"
import script from "./CreateEmailGroupModal.vue?vue&type=script&lang=js"
export * from "./CreateEmailGroupModal.vue?vue&type=script&lang=js"
import style0 from "./CreateEmailGroupModal.vue?vue&type=style&index=0&id=297c1078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297c1078",
  null
  
)

export default component.exports